<template>
    <div class="flats-card">
        <div class="container">
            <div class="card-title" v-if="cardArr && filterCMSparams != null">
                <h1>
                    <span class="project">{{ cardArr.project.name }}</span><span class="dot">.</span>
                    <span v-if="cardArr.rooms.value != '0'" class="title">{{ cardArr.rooms.label }} {{ filterCMSparams.words_translation.flats_card_title }}, {{ cardArr.size }} м²</span> 
                    <span v-else class="title">{{ filterCMSparams.words_translation.studiya }}, {{ cardArr.size }} м²</span> 
                    <span class="class" v-if="isMobileChecker">{{ cardArr.class.name }}</span>
                </h1>
            </div>
            <div class="flat-card-plan-content" v-if="cardArr">
                <div class="column-images">
                    <div class="images-nav">
                        <ul>
                            <li @click="active = 'plan'" :class="{'active' : active == 'plan'}" class="btn-wow-effect-hover"><span>{{ filterCMSparams.words_translation.plan_flat_card }}</span></li>
                            <li @click="active = 'floor'" :class="{'active' : active == 'floor'}" class="btn-wow-effect-hover"><span>{{ filterCMSparams.words_translation.floor_flat_card }}</span></li>
                        </ul>
                    </div>
                    <div class="btn-resize-plan btn-wow-effect-hover" @click="initResizeElem(cardArr.plan, cardArr.plan_foor_big)">
                        <svgIcon name="resize" class="icon-resize"/>
                    </div>
                    <div class="plan-small-img" v-if="active != 'floor'">
                        <img :src="cardArr.plan_foor" alt="" v-if="cardArr.plan_foor != null && cardArr.plan_foor != ''">
                        <svgIcon name="none-img" class="icon-none-img" v-else/>
                    </div>
                    <div class="rose-img">
                        <img :src="cardArr.rose" alt="" v-if="cardArr.rose != null && cardArr.rose != ''">
                        <svgIcon name="none-img" class="icon-none-img" v-else/>
                    </div>
                    <div class="plan-img" v-if="active != 'floor'">
                        <img :src="cardArr.plan" alt="" v-if="cardArr.plan != null && cardArr.plan != ''">
                        <svgIcon name="none-img" class="icon-none-img" v-else/>
                    </div>
                    <div class="floor-img" v-if="active != 'plan'">
                        <img :src="cardArr.plan_foor_big" alt="" v-if="cardArr.plan_foor_big != null && cardArr.plan_foor_big != ''">
                        <svgIcon name="none-img" class="icon-none-img" v-else/>
                    </div>
                </div>
                <div class="column-info">
                    <div class="info-links">
                        <div class="link-item" v-if="cardArr.pdf != false && cardArr.pdf != null">
                            <a :href="cardArr.pdf" target="_blank" download>
                                <svgIcon name="pdf" class="icon-pdf"/>
                            </a>
                        </div>
                        <div class="link-item link-item-share">
                            <div class="social-links-container">
                                <div class="soc-link-in">
                                    <SWhatsApp
                                        :share-options="{
                                            text: 'Ваша ' + cardArr.rooms.value + '-комнатная квартира ' +  cardArr.size + 'м², в жилом комплексе ' +  cardArr.project.name + ', ' + 'https://dialgroup.kz/flats/' + cardID
                                        }"
                                        :use-native-behavior="true"
                                    ><svgIcon name="wapp" class="icon-soc icon-wapp"/></SWhatsApp>
                                    <STelegram
                                        :share-options="{
                                            text: 'Ваша ' + cardArr.rooms.value + '-комнатная квартира ' +  cardArr.size + 'м², в жилом комплексе ' +  cardArr.project.name,
                                            url: 'https://dialgroup.kz/flats/' + cardID
                                        }"
                                        :use-native-behavior="true"
                                    ><svgIcon name="telapp" class="icon-soc icon-telapp"/></STelegram>
                                </div>
                            </div>
                            <svgIcon name="share" class="icon-share"/>
                        </div>
                        <div class="link-item link-favorite">
                            <svgIcon name="favorite-disactive" class="icon-favorite"/>
                            <svgIcon name="favorite-active" class="icon-favorite-active"/>
                        </div>
                        <div class="link-item btn-consult" @click="openFormConsult(cardArr)">
                            <span v-if="globalLang != 'kz/'">Оставить заявку</span>
                            <span v-else>Өтінім қалдыру</span>
                            <svgIcon name="arrow-right" class="icon-right-arrow"/>
                        </div>
                    </div>
                    <div class="info-head">
                        <h2>
                            <span v-if="cardArr.rooms.value != '0'">{{ cardArr.rooms.label }} {{ filterCMSparams.words_translation.flats_card_title }}</span> 
                            <span v-else>{{ filterCMSparams.words_translation.studiya }}</span> 
                        </h2>
                        <div class="calss"><span>{{ cardArr.class.name }}</span></div>
                    </div>
                    <div class="info-list">
                        <ul>
                            <li>
                                <div class="info-label">{{ filterCMSparams.words_translation.project }}</div>
                                <div class="info-value info-value-project">{{ cardArr.project.name }}</div>
                            </li>
                            <li>
                                <div class="info-label">{{ filterCMSparams.words_translation.part }}</div>
                                <div class="info-value">{{ parseInt(cardArr.part.label) }}</div>
                            </li>
                            <li>
                                <div class="info-label">{{ filterCMSparams.words_translation.size }}</div>
                                <div class="info-value size-value">{{ cardArr.size }} <span v-if="isMobileChecker">м²</span></div>
                            </li>
                            <li>
                                <div class="info-label">{{ filterCMSparams.words_translation.height }}</div>
                                <div class="info-value size-value">{{ cardArr.height }} <span v-if="isMobileChecker">м²</span></div>
                            </li>
                        </ul>
                    </div>
                    <div class="info-price">
                        <div class="price-full"><span>{{ getNumber(cardArr.price_full) }}</span> тг</div>
                    </div>
                    <!-- <div class="btn-consult" @click="openFormConsult(cardArr)">
                        <span v-if="globalLang != 'kz/'">Оставить заявку</span>
                        <span v-else>Өтінім қалдыру</span>
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </div> -->
                </div>
            </div>
        </div>
        <transition name="fade" mode="out-in">
            <flatsCardResizeElem v-if="resizeInit"></flatsCardResizeElem>
        </transition>
        <PromoPayment></PromoPayment>
        <PromoSalesOther></PromoSalesOther>
        <formPage></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import flatsCardResizeElem from '@/components/flats-page/flats-card-resize-elem.vue'
    import PromoPayment from '@/components/home-page/promo-payment.vue'
    import PromoSalesOther from '@/components/home-page/promo-other-sales.vue'
    import formPage from '@/components/forms/form-page.vue'
    import { STelegram, SWhatsApp } from 'vue-socials'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'flats--card',
        components: {
            // flatsFilter,
            flatsCardResizeElem,
            PromoPayment,
            PromoSalesOther,
            formPage,
            svgIcon,
            SWhatsApp,
            STelegram,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                cardID: this.$route.params.id,
                cardArr: null,
                active: 'plan',
            }
        },
        computed: mapGetters({
            filterCMSparams: 'loadFilterCMSparams',
            // flatsItemsArr: 'loadFlatsItems',
            // flatsListView: 'loadFlatsListView',
            // filterFlatsDataBase: 'loadFilterFlatsData',
            // isOpenFilterMobile: 'loadOpenFlatsMobileFilter',
            isMobileChecker: 'loadIsMobileChecker',
            resizeInit: 'loadFlatsResizeElemInit',
            // aboutPage: 'loadAboutPage',
        }),
        methods: {
            initResizeElem(plan, floor) {
                var data;
                if (this.active == 'plan') {
                    data = plan
                } else {data = floor}
                this.$store.commit('flatsResizeElemInit', true);
                this.$store.commit('flatsResizeImgSet', data);
                document.getElementsByTagName('body')[0].classList.add('overlay-open');
                document.getElementById('header').classList.add('visibilityHide');
                document.getElementById('footer').classList.add('visibilityHide');
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ")
            },
            openFormConsult(arr) {
                var dataArr = {
                    project: arr.project.name,
                    id: this.cardID,
                    part: arr.part.label,
                    rooms: arr.rooms.label,
                    size: arr.size + ' м²',
                    price: this.getNumber(arr.price_full) + ' тг.',
                    link: 'https://dialgroup.kz/flats/' + this.cardID,
                };
                // console.log(dataArr, 'form data arr')
                this.$store.commit('formsModalRealEstate_setData', dataArr);
                this.$store.commit('formGlobalDataModal_set', {'page' : 'flats-card', 'block' : 'Информация о квартире'});
                this.$store.commit('formGlobalParam_set', 'flats-form');
                this.$store.commit('formModalContainerOpen');
            },  
        },
        beforeRouteEnter (to, from, next) {
            // console.log(to);
            // store.dispatch('getNewsItems');
            // store.dispatch('getNewsPageData');
            store.dispatch('getPaymentPageData');
            store.dispatch('getIndexPageData');
            axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/flats/' + to.params.id).then(async (response) => {
                console.log(response, 'ASDASDASD');
                if (response.data.length != 0) {
                    next(vm => {
                        vm.cardArr = response.data.acf;
                        // vm.$store.commit('removePageLoaderImg');
                        // vm.$parent.$refs.topProgress.done();
                    });
                } else {
                    next('/404');
                    //PUSH ON 404 PAGE
                }
            });
        },
        beforeCreate() {
            // this.$store.dispatch('getFlatsItems');
            document.body.dataset.page = 'flats-card';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-page/flats-card.scss';
    @import '@/styles/components/flats-page/respond/flats-card-respond.scss';
    // @import '@/styles/components/flats-page/respond/flats-page-respond.scss';
</style>